import { render, staticRenderFns } from "./maindep.vue?vue&type=template&id=8e1631b8"
import script from "./maindep.vue?vue&type=script&lang=js"
export * from "./maindep.vue?vue&type=script&lang=js"
import style0 from "./maindep.vue?vue&type=style&index=0&id=8e1631b8&prod&lang=less"
import style1 from "./maindep.vue?vue&type=style&index=1&id=8e1631b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports